export enum BAErrorCode {
  SINGLE_SIGN_ON_GENERIC_ERROR = 'SSOGenericError',
  GENERIC_UNAUTHORIZED = 'GenericUnauthorizedError',
  PLAYER_NOT_FOUND = 'PlayerNotFound',
}

export type BAError = {
  code: BAErrorCode;
  message: string;
  data?: { [key: string]: string };
  traceId?: string;
};
